export default "__VITE_ASSET__CDFt6$he__"